module.exports = __webpack_public_path__ + "img/cd8e31c.png";